import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMaltiaResponse, MaltiaResponse } from '../../models/maltia-response.model';
import { SpinnerService } from '../spinner/spinner.service';
import { ToastService } from '../toast/toast.service';
import { environment } from '../../../environments/environment';
import { IZorroInsightResponse } from '../../models/zorro-insight-response.model';

@Injectable({
  providedIn: 'root'
})
export class InsightsService {

  dailyMeter: any;
  weeklyMeter: any;

  constructor(
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService,
  ) { }

  /*
   ██████╗ ███████╗████████╗
  ██╔════╝ ██╔════╝╚══██╔══╝
  ██║  ███╗█████╗     ██║
  ██║   ██║██╔══╝     ██║
  ╚██████╔╝███████╗   ██║
   ╚═════╝ ╚══════╝   ╚═╝

  */
  // region get
  async get(): Promise<MaltiaResponse<IZorroInsightResponse>> {
    const urlApi = `${environment.urlApi}/v1.0/Dashboards/measured-fox-store-referrals`;

    let response: MaltiaResponse;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Recuperando la información';

    try {
      response = await new Promise<IMaltiaResponse<IZorroInsightResponse>>(
        (resolve, reject) => {
          this.http.get<IMaltiaResponse<IZorroInsightResponse>>(
            urlApi,
            {
              headers: {
                'Content-Type': 'application/json',
              }
            }
          ).subscribe({
            next: (response: IMaltiaResponse<IZorroInsightResponse>) => resolve(
              new MaltiaResponse(response)
            ),
            error: (error: any) => {
              if (error.error)
                resolve(new MaltiaResponse(error.error));
              else {
                reject(error);
                this.toastService.show({
                  header: 'Error en el servidor',
                  body: `${error}`,
                  classname: 'bg-danger text-white'
                });
              }
            }
          });
        }
      );

      // console.log('response=>', response);

      if (response.code === 200) {
        // this.toastService.show({
        //   body: 'Información recuperada correctamente',
        //   classname: 'bg-success text-white'
        // });
      }
      else {
        this.toastService.show({
          header: 'Error',
          body: response.message,
          classname: 'bg-danger text-white'
        });
      }
    }
    catch (error) {
      console.error(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });

      response = new MaltiaResponse({
        error: true,
        code: 500,
        message: `${error}`,
        data: null
      });
    }

    finally {
      this.spinnerService.loading = false;
      this.spinnerService.message = '';
    }

    return response;
  }

}
